export var isArrayLike = function isArrayLike(x) {
  return x != null && typeof x !== "function" && x.length !== undefined;
};